/** Pure pre-flight check for the sandbox-create request body (Cloudflare rejects oversized bodies with a bare 413). */
export const MAX_SYNC_PAYLOAD_BYTES = 50 * 1024 * 1024;

export interface SyncFileLike {
  path: string;
  content: string;
}

export function checkSyncPayload(
  files: SyncFileLike[],
  maxBytes: number = MAX_SYNC_PAYLOAD_BYTES,
): { totalBytes: number; largest: { path: string; bytes: number }[] } {
  const sized = files.map((f) => ({ path: f.path, bytes: Buffer.byteLength(f.content, 'utf-8') }));
  const totalBytes = sized.reduce((sum, f) => sum + f.bytes, 0);
  const largest = [...sized].sort((a, b) => b.bytes - a.bytes).slice(0, 5);
  if (totalBytes > maxBytes) {
    const mb = (n: number) => (n / 1024 / 1024).toFixed(1);
    throw new Error(
      `Config sync payload is ${mb(totalBytes)} MB (limit ${mb(maxBytes)} MB). Largest files:\n` +
        largest.map((f) => `  ${mb(f.bytes)} MB  ${f.path}`).join('\n') +
        `\nRemove or shrink these files and retry.`,
    );
  }
  return { totalBytes, largest };
}
